import styles from '@/components/elements/BrandedBox/BrandedBox.module.scss'
import TitleDecoration from '@/components/cms/TitleDecoration'

const BrandedBox = ({ className, children }: any) => {
  return (
    <div className={`${styles.root} ${className}`}>
      <TitleDecoration className={styles.titleDecoration} />
      {children}
    </div>
  )
}

export default BrandedBox
